import useUser from 'user-module/user/core/useUser'
import Amount from 'shared-module/components/amount/Amount'

const SpyDollars = () => {
  const user = useUser()
  return user.isAuthenticated ? <Amount value={user?.spydollars} currencyCode={user?.currencyCode} /> : null
}

export default SpyDollars
